var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeedbackCommingSoon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 186.664,
    height: 198.607,
    viewBox: "0 0 186.664 198.607",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#f5f5f5;}.b{fill:#e0e0e0;}.c{fill:#d2ebf7;}.d{fill:#455a64;}.e{fill:#263238;}.f{fill:#3c9cf9;}.g{fill:#eb996e;}.h{fill:#ffbe9d;}.i,.j{opacity:0.2;}.k{fill:#e8505b;}.l{opacity:0.3;}.m{fill:#4c49a2;}.n{fill:#fafafa;}.o{opacity:0.7;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-3417.332 611.931)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3364 -648.293)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(53.332 64.112)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 54.439)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M53.332,215.691v22.78a7.462,7.462,0,0,0,7.462,7.463h81.682a7.463,7.463,0,0,0,7.463-7.463V219.223l10.169-10.684-99.291-.31A7.462,7.462,0,0,0,53.332,215.691Z",
    transform: "translate(-53.332 -208.229)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.446 11.181)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M149.3,234.23l-74.121-.342.008-2.278,74.121.343Z",
    transform: "translate(-75.176 -231.609)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.446 18.676)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M149.3,249.9l-74.121-.342.008-2.278,74.121.342Z",
    transform: "translate(-75.176 -247.282)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(55.238 26.179)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 2.278,
    height: 29.328,
    transform: "translate(0 2.278) rotate(-89.718)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(75.686 133.152)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M211.6,380.291v22.78a7.463,7.463,0,0,0,7.462,7.463h81.682a7.463,7.463,0,0,0,7.463-7.463V383.822l10.169-10.684-99.291-.31A7.463,7.463,0,0,0,211.6,380.291Z",
    transform: "translate(-211.602 -372.828)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.801 10.589)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M308.309,397.592l-74.121-.342.008-2.278,74.121.342Z",
    transform: "translate(-234.188 -394.971)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.801 18.084)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M308.309,413.265l-74.121-.342.008-2.278,74.121.343Z",
    transform: "translate(-234.188 -410.644)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(55.593 25.588)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 2.278,
    height: 29.328,
    transform: "translate(0 2.278) rotate(-89.718)"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M144.63,44.39h48.177a4.318,4.318,0,0,1,4.318,4.318V72.272a4.318,4.318,0,0,1-4.318,4.318H151.926a4.318,4.318,0,0,1-4.318-4.318V47.367Z",
    transform: "translate(-100.97 -44.39)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.769 17.959)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M125.759,86.893V102a4.95,4.95,0,0,1-4.949,4.95H66.635a4.95,4.95,0,0,1-4.95-4.95V89.236L54.94,82.15l65.854-.206A4.95,4.95,0,0,1,125.759,86.893Z",
    transform: "translate(-54.94 -81.944)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.726 7.415)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M85.738,99.189l49.161-.227-.005-1.511-49.16.227Z",
    transform: "translate(-85.733 -97.451)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.726 12.386)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M85.738,109.584l49.161-.227-.005-1.511-49.16.227Z",
    transform: "translate(-85.733 -107.846)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.724 17.363)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 19.452,
    height: 1.511,
    transform: "translate(0 0.096) rotate(-0.282)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(103.398 64.111)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M340.37,233.4v15.109a4.95,4.95,0,0,1-4.95,4.949H281.246a4.95,4.95,0,0,1-4.95-4.949V235.746l-6.745-7.086,65.854-.206A4.95,4.95,0,0,1,340.37,233.4Z",
    transform: "translate(-269.551 -228.454)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.725 7.416)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M300.349,245.7l49.161-.227-.005-1.511-49.16.227Z",
    transform: "translate(-300.344 -243.961)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.725 12.387)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M300.349,256.094l49.161-.227-.005-1.511-49.16.227Z",
    transform: "translate(-300.344 -254.356)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.724 17.363)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 19.452,
    height: 1.511,
    transform: "translate(0 0.096) rotate(-0.282)"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(106.192 36.363)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(30.689 170.36)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M230.318,393.591a1.151,1.151,0,1,1-1.133-.983A1.066,1.066,0,0,1,230.318,393.591Z",
    transform: "translate(-228.043 -392.608)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.524 0.016)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M237.687,393.625a1.15,1.15,0,1,1-1.133-.983A1.066,1.066,0,0,1,237.687,393.625Z",
    transform: "translate(-235.413 -392.642)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.048 0.033)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M245.057,393.658a1.151,1.151,0,1,1-1.133-.982A1.066,1.066,0,0,1,245.057,393.658Z",
    transform: "translate(-242.782 -392.676)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(68.326 7.911)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M306.873,52.9c.068,0,.124,2.98.124,6.655s-.056,6.656-.124,6.656-.125-2.979-.125-6.656S306.8,52.9,306.873,52.9Z",
    transform: "translate(-306.748 -52.905)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(79.859 23.225)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M343.042,84.932c.028.063-2.676,1.317-6.038,2.8s-6.112,2.636-6.139,2.573,2.675-1.317,6.039-2.8S343.015,84.87,343.042,84.932Z",
    transform: "translate(-330.865 -84.93)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(76.142)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M338.391,36.363a1.276,1.276,0,0,1-.128.255l-.409.7c-.357.612-.892,1.485-1.56,2.56-1.339,2.148-3.266,5.068-5.449,8.252s-4.131,6.086-5.507,8.208l-1.626,2.516-.449.68a1.216,1.216,0,0,1-.171.228,1.209,1.209,0,0,1,.128-.254l.409-.705c.357-.611.892-1.485,1.56-2.56,1.339-2.148,3.267-5.068,5.45-8.254s4.13-6.084,5.507-8.207l1.626-2.516.448-.68A1.215,1.215,0,0,1,338.391,36.363Z",
    transform: "translate(-323.092 -36.363)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(70.342 92.662)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(48.329)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M301.991,154.092H194.181a4.216,4.216,0,0,0-4.216,4.216V191.75a4.217,4.217,0,0,0,4.216,4.216h8.032c.647,3.492,1.4,7.9,1.4,7.9l7.27-7.9h91.1a4.216,4.216,0,0,0,4.216-4.216V158.308A4.216,4.216,0,0,0,301.991,154.092Z",
    transform: "translate(-189.965 -154.092)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.23 12.875)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 5.141)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M268.673,191.889c0,.069-12.831.124-28.656.124s-28.659-.055-28.659-.124,12.829-.124,28.659-.124S268.673,191.82,268.673,191.889Z",
    transform: "translate(-211.358 -191.765)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M268.673,181.14c0,.068-12.831.124-28.656.124s-28.659-.056-28.659-.124,12.829-.125,28.659-.125S268.673,181.071,268.673,181.14Z",
    transform: "translate(-211.358 -181.015)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 10.225)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M268.673,202.52c0,.069-12.831.125-28.656.125s-28.659-.056-28.659-.125,12.829-.124,28.659-.124S268.673,202.451,268.673,202.52Z",
    transform: "translate(-211.358 -202.396)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 15.491)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M248.9,213.532c0,.069-8.4.125-18.77.125s-18.772-.056-18.772-.125,8.4-.124,18.772-.124S248.9,213.464,248.9,213.532Z",
    transform: "translate(-211.358 -213.408)"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 60.122)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M200.546,279.816H91.852a2.95,2.95,0,0,0-2.95,2.95v35.381a2.95,2.95,0,0,0,2.95,2.95h78.942l7.186,7.808s.754-4.389,1.389-7.808h21.177a2.95,2.95,0,0,0,2.95-2.95V282.766A2.95,2.95,0,0,0,200.546,279.816Z",
    transform: "translate(-88.902 -279.816)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(50.065 12.98)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 5.141)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M250.91,317.832c0,.069-12.832.124-28.656.124s-28.659-.055-28.659-.124,12.828-.124,28.659-.124S250.91,317.763,250.91,317.832Z",
    transform: "translate(-193.595 -317.708)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M250.91,307.083c0,.068-12.832.124-28.656.124s-28.659-.056-28.659-.124,12.828-.125,28.659-.125S250.91,307.014,250.91,307.083Z",
    transform: "translate(-193.595 -306.958)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 10.225)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M250.91,328.463c0,.069-12.832.124-28.656.124s-28.659-.055-28.659-.124,12.828-.124,28.659-.124S250.91,328.394,250.91,328.463Z",
    transform: "translate(-193.595 -328.339)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 15.491)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M231.137,339.475c0,.069-8.4.125-18.77.125s-18.772-.056-18.772-.125,8.4-.124,18.772-.124S231.137,339.407,231.137,339.475Z",
    transform: "translate(-193.595 -339.351)"
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(188.112 63.6)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M364.954,108.2a4.323,4.323,0,0,0-1.446-2.788,2.86,2.86,0,0,1-.8-3.046c.293-1.086.981-1.005,1.253-1.643a4.829,4.829,0,0,0,.158-1.524,3.175,3.175,0,0,1,3.785-2.7,4.4,4.4,0,0,1,8.111-.845,3.383,3.383,0,0,1,4.933,2.745,2.462,2.462,0,0,1,3.2.483,3.034,3.034,0,0,1,.23,3.344,3.979,3.979,0,0,1-2.874,1.893,5.841,5.841,0,0,1-3.451-.627,11.171,11.171,0,0,1-2.831-2.139",
    transform: "translate(-349.471 -93.32)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "b",
    cx: 20.702,
    cy: 20.216,
    rx: 20.702,
    ry: 20.216,
    transform: "translate(2.601 29.397)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 4.934)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.174)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M415.909,190.693l-2.292-5.876-8.212,5.16,7.318,11.284A19.362,19.362,0,0,0,415.909,190.693Z",
    transform: "translate(-374.994 -145.996)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.112)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0.823)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.606)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M373.932,136.511h0a5.509,5.509,0,0,0,5.532-5.209c.121-2.433.223-4.776.223-4.776s4.518-.327,4.935-4.743.474-14.63.474-14.63h0a15.673,15.673,0,0,0-15.736.683l-.43.276-.522,22.855A5.509,5.509,0,0,0,373.932,136.511Z",
    transform: "translate(-368.407 -105.359)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.097 8.117)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.166 0.437)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M384.449,123.279a.644.644,0,0,1,.412.814.651.651,0,0,1-.821.408.643.643,0,0,1-.413-.814A.651.651,0,0,1,384.449,123.279Z",
    transform: "translate(-383.595 -123.246)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M385.506,123.032c-.075.073-.493-.288-1.108-.327s-1.081.249-1.144.166c-.031-.037.047-.171.251-.306a1.53,1.53,0,0,1,1.8.128C385.484,122.857,385.542,123,385.506,123.032Z",
    transform: "translate(-383.247 -122.333)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.921 8.131)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.084 0.423)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M398.548,123.279a.643.643,0,0,1,.412.814.651.651,0,0,1-.822.408.644.644,0,0,1-.412-.814A.651.651,0,0,1,398.548,123.279Z",
    transform: "translate(-397.694 -123.246)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M399.777,123.061c-.075.073-.493-.288-1.108-.328s-1.081.249-1.144.167c-.032-.037.046-.171.25-.307a1.531,1.531,0,0,1,1.8.129C399.755,122.885,399.813,123.029,399.777,123.061Z",
    transform: "translate(-397.519 -122.362)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.54 8.283)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M392.539,128a3,3,0,0,1,1.01-.129c.162,0,.291-.03.31-.115a.859.859,0,0,0-.078-.465l-.384-1.276a16.9,16.9,0,0,1-.786-3.337,16.888,16.888,0,0,1,1.123,3.241l.358,1.284a1.012,1.012,0,0,1,.034.669.421.421,0,0,1-.3.232,1.031,1.031,0,0,1-.277.013A3.011,3.011,0,0,1,392.539,128Z",
    transform: "translate(-392.539 -122.679)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.611 18.997)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M385.822,147.19a10.471,10.471,0,0,1-5.681-2.107s1.114,3.292,5.6,3.253Z",
    transform: "translate(-380.141 -145.083)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 8.554)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M365.978,123.932a.67.67,0,0,0-.631-.682c-.833-.039-2.2.262-2.375,2.539-.246,3.252,2.93,2.5,2.942,2.409C365.925,128.124,365.962,125.2,365.978,123.932Z",
    transform: "translate(-362.959 -123.246)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.879 1.036)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M366.174,128.034c-.013-.011-.06.035-.16.072a.578.578,0,0,1-.428-.023,1.4,1.4,0,0,1-.559-1.307,1.861,1.861,0,0,1,.221-.8.66.66,0,0,1,.463-.4.293.293,0,0,1,.326.18c.037.094.011.158.028.165s.075-.049.058-.186a.36.36,0,0,0-.114-.213.435.435,0,0,0-.31-.107.8.8,0,0,0-.635.46,1.915,1.915,0,0,0-.267.891,1.472,1.472,0,0,0,.727,1.467.619.619,0,0,0,.529-.047C366.162,128.112,366.185,128.041,366.174,128.034Z",
    transform: "translate(-364.796 -125.413)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.019 6.198)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M381.849,119.206c.162.208.728.111,1.462.08.733-.059,1.307-.031,1.44-.258.152-.236-.558-.778-1.5-.7C382.3,118.367,381.668,118.991,381.849,119.206Z",
    transform: "translate(-381.818 -118.32)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(16.201 6.169)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M396.847,118.958c.089.284.627.369,1.225.365s1.134-.111,1.216-.4-.459-.678-1.229-.667S396.756,118.682,396.847,118.958Z",
    transform: "translate(-396.837 -118.26)"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M385.688,107.652a7.341,7.341,0,0,1-6.167-.443c-2.288-1.142-4.956-1.7-5.544-1.24s-.712,2.819-2.979,3.507c0,0,.155,4.5-1.638,4.339s-.673-7.129-.673-7.129l4.389-2.143,4.789-.9,4.512.636,3.491.956Z",
    transform: "translate(-365.766 -103.637)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 22.407)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 3.331)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M341.812,161.771c4.689-4.823,12.944-4.3,12.944-4.3l6.842,4.9,3.88-4.517a25.158,25.158,0,0,1,7.9,2.444l.263.081,0,.055c3,1.63,7.251,5.539,11.3,9.332l-4.845,4.5-5.362,4.76a.144.144,0,0,1,.009.1c-.056.288.745,6.836,1.566,11.812a20.191,20.191,0,0,1-18.019,5.444A53.645,53.645,0,0,1,353,194.923a7.356,7.356,0,0,1-5.447-6.482h0c-.365-4.171-.644-9.335-.644-9.335",
    transform: "translate(-341.812 -157.458)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(27.954 1.239)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M400.27,160.048a5.211,5.211,0,0,1,.295.77c.175.5.414,1.229.7,2.134.565,1.809,1.284,4.329,1.964,7.14s1.188,5.384,1.512,7.251c.162.934.282,1.691.354,2.216a5.281,5.281,0,0,1,.089.819,5.121,5.121,0,0,1-.185-.8c-.11-.56-.256-1.3-.432-2.2-.367-1.857-.9-4.417-1.581-7.225s-1.37-5.329-1.891-7.149l-.62-2.155A5.22,5.22,0,0,1,400.27,160.048Z",
    transform: "translate(-400.267 -160.048)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(32.361 10.905)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M409.483,187.837c-.043-.054,2-1.792,4.569-3.883s4.683-3.743,4.726-3.69-2,1.791-4.569,3.883S409.527,187.89,409.483,187.837Z",
    transform: "translate(-409.483 -180.262)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M350.177,180.32l-4.2,13.808,1.562.812,1.54-3.905S350.664,182.832,350.177,180.32Z",
    transform: "translate(-343.986 -169.387)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "j",
    transform: "translate(21.532 0.326)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M392.807,159.061c2.262,1.193-3.408,4.063-5.969,3.986l1.86-4.907A25.819,25.819,0,0,1,392.807,159.061Z",
    transform: "translate(-386.838 -158.139)"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M367.468,154.149v-3.656s7.142,1.838,7.4,6.111c0,0,.908-4.723,4.588-4.95l.519,6.644-4.281,3.725h-4.34l-3.438-2.965-.449-4.614",
    transform: "translate(-355.199 -150.493)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(19.625 6.757)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M384.5,184.473a4.7,4.7,0,0,1-.012-.786c.011-.505.02-1.237.022-2.14.006-1.805-.05-4.3-.277-7.045s-.585-5.216-.889-7l-.375-2.106a4.748,4.748,0,0,1-.118-.778,4.767,4.767,0,0,1,.212.757c.123.491.279,1.207.453,2.095a65.608,65.608,0,0,1,1.169,14.075c-.025.9-.061,1.636-.1,2.141A4.855,4.855,0,0,1,384.5,184.473Z",
    transform: "translate(-382.85 -164.623)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.006 2.966)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M374.254,158.61a.864.864,0,0,0-.424.039c-.273.088-.517.428-.717.913a20.684,20.684,0,0,0-1.358,3.951l-.038.163-.144-.087c-.427-.258-.865-.537-1.305-.835A26.147,26.147,0,0,1,367.952,161a2.925,2.925,0,0,1-.789-1.032,3.254,3.254,0,0,1-.241-1.1,6.388,6.388,0,0,1,.159-1.6,2.364,2.364,0,0,1,.156-.566,3.04,3.04,0,0,1-.061.582,7.557,7.557,0,0,0-.078,1.571,3.164,3.164,0,0,0,.254,1.03,2.747,2.747,0,0,0,.751.944c.675.564,1.46,1.152,2.3,1.726.437.3.87.574,1.292.833l-.182.076a18.069,18.069,0,0,1,1.453-3.964,3,3,0,0,1,.376-.615.956.956,0,0,1,.456-.309C374.106,158.484,374.266,158.606,374.254,158.61Z",
    transform: "translate(-366.919 -156.695)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(20.217 1.161)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M388.13,152.921a2.622,2.622,0,0,1,.067.571l.114,1.556c.054.656.133,1.435.267,2.293a3.835,3.835,0,0,1,.086,1.4,2.412,2.412,0,0,1-.94,1.2,10.573,10.573,0,0,0-1.571,1.194l-.19.213-.019-.285a8.553,8.553,0,0,0-1.055-3.561c-.454-.814-.828-1.233-.8-1.257a1.353,1.353,0,0,1,.282.282,7.031,7.031,0,0,1,.647.9,8.158,8.158,0,0,1,1.163,3.621l-.209-.071a10.035,10.035,0,0,1,1.6-1.233,2.213,2.213,0,0,0,.853-1.062,3.78,3.78,0,0,0-.076-1.309c-.123-.867-.185-1.654-.216-2.315s-.037-1.2-.035-1.564A2.5,2.5,0,0,1,388.13,152.921Z",
    transform: "translate(-384.089 -152.921)"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 24.486)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.558)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M428.818,154.84c-.29.342-10.8,14.4-10.8,14.4l1.48.839,10.789-13.88Z",
    transform: "translate(-380.957 -154.84)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M346.147,173.19s11.061,15.921,11.727,16.234c1.313.616,16.445-12.46,17.887-13.711.2-.265.609-.826,1.415-1.942,0,0,1.194-5.463,2.468-5.043s-.7,2.776.132,4.851,4.63-2.875,4.782-3.319l.98-1.281a16.817,16.817,0,0,1,.958,4.13c-.223,3.9-3.911,8.533-3.911,8.533s-16.56,20.514-27.9,21.151c-3.267.183-9.073-9.087-12.955-16.039a9.512,9.512,0,0,1,2.71-12.319Z",
    transform: "translate(-340.524 -162.075)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(44.109 8.847)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M432.764,176.221c-.037-.023.318-.649.709-1.442s.677-1.454.717-1.439a8.988,8.988,0,0,1-1.426,2.881Z",
    transform: "translate(-432.761 -173.339)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 3.345)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M341.484,161.835s-11.872,4.221-3.045,24.185l13.7-8.272-1.95-4.668Z",
    transform: "translate(-335.175 -161.835)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.264 0.328)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M344.135,162.538a4.122,4.122,0,0,1,1.429.12,5.817,5.817,0,0,1,1.557.657,8.416,8.416,0,0,1,1.73,1.419,20.735,20.735,0,0,1,3.225,4.818c1,1.941,1.942,4.152,2.9,6.475l.84,2.031.043.1-.1.053c-3.965,2.161-7.418,4.186-9.858,5.7-1.221.756-2.194,1.377-2.861,1.809l-.769.494a1.66,1.66,0,0,1-.276.16,1.629,1.629,0,0,1,.25-.2c.169-.122.417-.3.745-.53.652-.455,1.612-1.1,2.823-1.875,2.42-1.554,5.863-3.607,9.828-5.777l-.055.156c-.27-.649-.554-1.335-.842-2.031-.961-2.322-1.889-4.53-2.877-6.465a21.1,21.1,0,0,0-3.149-4.8,8.474,8.474,0,0,0-1.675-1.422,5.93,5.93,0,0,0-1.508-.682A8.568,8.568,0,0,0,344.135,162.538Z",
    transform: "translate(-342 -162.52)"
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(21.344 3.511)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M389.4,100.661a.712.712,0,0,1,.059.208,2.71,2.71,0,0,1,.034.62,3.17,3.17,0,0,1-4.1,2.877,2.823,2.823,0,0,1-1.636-1.186,1.669,1.669,0,0,1-.245-1.08,1.4,1.4,0,0,1,.587-.987,1.213,1.213,0,0,1,1.148-.074,1.459,1.459,0,0,1,.785.789,2.094,2.094,0,0,1-.314,1.988,2.494,2.494,0,0,1-3.136.681,5.355,5.355,0,0,0-1.181-.453,1.485,1.485,0,0,0-.914.1,4.954,4.954,0,0,0-.68.448c-.006-.006.042-.062.14-.165a1.186,1.186,0,0,1,.2-.176,1.465,1.465,0,0,1,.3-.2,1.556,1.556,0,0,1,.978-.146,5.245,5.245,0,0,1,1.228.429,3.476,3.476,0,0,0,.69.228,2.182,2.182,0,0,0,.77-.014,2.26,2.26,0,0,0,1.42-.87,1.87,1.87,0,0,0,.274-1.758,1.127,1.127,0,0,0-1.571-.6,1.154,1.154,0,0,0-.478.812,1.43,1.43,0,0,0,.209.922,2.605,2.605,0,0,0,1.491,1.091,3.059,3.059,0,0,0,3.006-.711,3.249,3.249,0,0,0,.934-1.954A6.549,6.549,0,0,0,389.4,100.661Z",
    transform: "translate(-379.809 -100.661)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(26.008 20.365)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M391.906,137.085c.005.03-.147.093-.41.1a2.128,2.128,0,0,1-1.767-.89c-.147-.218-.187-.378-.16-.391a3.276,3.276,0,0,0,2.336,1.177Z",
    transform: "translate(-389.562 -135.906)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.25 18.618)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M366.535,133.065c.022-.021.156.21-.017.539a.8.8,0,0,1-.487.387.828.828,0,0,1-.743-.195.89.89,0,0,1-.314-.694.956.956,0,0,1,.218-.572c.23-.27.463-.3.467-.268s-.169.12-.324.371a.743.743,0,0,0,.117.976.63.63,0,0,0,.527.159.671.671,0,0,0,.391-.257C366.543,133.277,366.5,133.07,366.535,133.065Z",
    transform: "translate(-364.973 -132.253)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(28.395 5.122)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M397.883,104.03a1.575,1.575,0,0,1,.23.878,2.92,2.92,0,0,1-2.658,3.066,1.577,1.577,0,0,1-.9-.1c.006-.043.348.021.878-.071a2.952,2.952,0,0,0,2.506-2.889C397.952,104.371,397.842,104.041,397.883,104.03Z",
    transform: "translate(-394.553 -104.029)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.358 45.131)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M352.21,187.7c.031.062-3.123,1.683-7.042,3.621s-7.123,3.459-7.154,3.4,3.122-1.682,7.043-3.621S352.18,187.635,352.21,187.7Z",
    transform: "translate(-338.015 -187.695)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.024 39.707)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M347.88,176.355c.033.061-2.775,1.631-6.269,3.506s-6.354,3.347-6.387,3.287,2.774-1.63,6.269-3.506S347.848,176.295,347.88,176.355Z",
    transform: "translate(-335.224 -176.353)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.213 35.321)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M345.311,167.183a11.4,11.4,0,0,1-1.4.831l-3.433,1.915-3.415,1.948a11.262,11.262,0,0,1-1.438.772,9.949,9.949,0,0,1,1.347-.922c.852-.539,2.044-1.258,3.384-2.014s2.572-1.4,3.473-1.854A9.934,9.934,0,0,1,345.311,167.183Z",
    transform: "translate(-335.62 -167.181)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.446 30.305)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M372.434,160.673a2.243,2.243,0,0,1-.923-.249,7.078,7.078,0,0,1-1.934-1.259,13.257,13.257,0,0,1-1.559-1.689,3.466,3.466,0,0,1-.54-.784,3.787,3.787,0,0,1,.674.669,22.531,22.531,0,0,0,1.591,1.617,8.862,8.862,0,0,0,1.843,1.285C372.1,160.528,372.445,160.635,372.434,160.673Z",
    transform: "translate(-367.475 -156.692)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(24.806 31.695)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M389.623,159.6a3.329,3.329,0,0,1-2.575,2.168,16.688,16.688,0,0,0,1.421-.925A16.954,16.954,0,0,0,389.623,159.6Z",
    transform: "translate(-387.047 -159.598)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.266 38.886)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M389.466,174.643a1.15,1.15,0,0,1-.267.05l-.769.095c-.669.074-1.638.167-2.838.261-2.4.191-5.717.378-9.385.512s-6.993.178-9.4.158c-1.2-.008-2.176-.032-2.849-.058l-.774-.04a1.089,1.089,0,0,1-.269-.031,1.115,1.115,0,0,1,.27-.019l.774-.007,2.847-.022c2.4-.025,5.724-.1,9.391-.231s6.983-.293,9.382-.439l2.841-.181.773-.048A1.108,1.108,0,0,1,389.466,174.643Z",
    transform: "translate(-362.916 -174.636)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.861 44.555)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M388.521,186.5a4.864,4.864,0,0,1-.786.124c-.507.064-1.244.143-2.155.225-1.821.168-4.343.341-7.132.455s-5.318.142-7.147.122c-.914-.008-1.655-.028-2.166-.05a4.824,4.824,0,0,1-.793-.06,4.82,4.82,0,0,1,.794-.037l2.164-.029c1.827-.025,4.351-.083,7.137-.2s5.305-.259,7.129-.381l2.159-.146A4.967,4.967,0,0,1,388.521,186.5Z",
    transform: "translate(-368.343 -186.491)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(16.575 51.542)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M380.728,201.117a9.582,9.582,0,0,1-1.585.223c-.983.1-2.344.21-3.849.285s-2.872.1-3.86.1a9.52,9.52,0,0,1-1.6-.065,10.9,10.9,0,0,1,1.6-.111l3.851-.171,3.848-.212A10.857,10.857,0,0,1,380.728,201.117Z",
    transform: "translate(-369.835 -201.101)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.959 34.847)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M362.55,166.3c0,.071-1.469.087-3.274.163s-3.269.177-3.277.106a24.436,24.436,0,0,1,6.551-.269Z",
    transform: "translate(-356 -166.189)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(28.185 34.561)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M402.612,165.732a72.531,72.531,0,0,1-8.5-.032,72.53,72.53,0,0,1,8.5.032Z",
    transform: "translate(-394.114 -165.591)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(25.111 63.798)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M399.992,226.734a1.943,1.943,0,0,1-.436.25c-.286.149-.711.344-1.244.567a27.189,27.189,0,0,1-8.76,2.019c-.576.033-1.043.043-1.366.035a1.96,1.96,0,0,1-.5-.034c0-.04.711-.067,1.854-.176a33.541,33.541,0,0,0,8.709-2.008C399.323,226.984,399.975,226.7,399.992,226.734Z",
    transform: "translate(-387.685 -226.731)"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(67.163 123.379)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "b",
    cx: 20.702,
    cy: 19.748,
    rx: 20.702,
    ry: 19.748,
    transform: "translate(8.488 29.614)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.552)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M124.2,221.982c-3.284.171-4.574,3.595-4.966,4.359a6.623,6.623,0,0,0-.527,2.505,5.449,5.449,0,0,1-.63,2.473c-.723,1.153-2.242,1.75-2.655,3.047-.468,1.467.733,3.036.413,4.542-.172.808-.762,1.474-.97,2.273a3.347,3.347,0,0,0,.443,2.483,6.505,6.505,0,0,0,5.457,2.859,19.207,19.207,0,0,0,6.287-1.2",
    transform: "translate(-114.776 -220.234)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M161.461,230.88a2.046,2.046,0,0,0,.486,2.116,13.184,13.184,0,0,0,1.777,1.449,2.9,2.9,0,0,1,1.214,1.876c.064.7-.288,1.4-.193,2.092.245,1.79,3.1,2.327,3.252,4.128.1,1.2-1.129,2.3-.788,3.454a5.476,5.476,0,0,0,.711,1.18,3.51,3.51,0,0,1-.913,4.244,6.977,6.977,0,0,1-4.375,1.481c-1.319.059-2.818-.156-3.595-1.224-.711-.977-.565-2.31-.423-3.51a122.831,122.831,0,0,0,.437-16.909",
    transform: "translate(-137.59 -224.877)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.492 1.347)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.054 2.875)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M131.111,254.87c.025-2.944,0-6.044,0-6.044s-3.786-.673-4.514-5.631c-.694-4.728.484-14.9.484-14.9h0c5.484-2.163,11.659-1.327,15.5,3.088h0l-.6,23.909a5.129,5.129,0,0,1-5.482,4.829h0A5.419,5.419,0,0,1,131.111,254.87Z",
    transform: "translate(-126.375 -227.155)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.703 7.808)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.03 0.577)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M130,245.256a.635.635,0,0,0,.6.648.606.606,0,0,0,.66-.564.635.635,0,0,0-.6-.648A.607.607,0,0,0,130,245.256Z",
    transform: "translate(-129.999 -244.69)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M127.854,244.136c.078.084.563-.266,1.246-.257,1.285.186,1.262.383,1.254.274.037-.037-.042-.187-.258-.349a1.741,1.741,0,0,0-1-.322,1.668,1.668,0,0,0-.992.308C127.889,243.95,127.816,244.1,127.854,244.136Z",
    transform: "translate(-127.845 -243.483)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.825 8.044)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.896 0.543)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M144.614,245.678a.636.636,0,0,0,.6.647.607.607,0,0,0,.66-.565.635.635,0,0,0-.6-.648A.608.608,0,0,0,144.614,245.678Z",
    transform: "translate(-144.614 -245.111)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M142.749,244.629c.078.084.563-.266,1.246-.257s1.179.357,1.254.275c.037-.037-.041-.187-.258-.348a1.744,1.744,0,0,0-1-.322,1.675,1.675,0,0,0-.993.308C142.784,244.443,142.711,244.591,142.749,244.629Z",
    transform: "translate(-142.739 -243.976)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.564 7.909)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M135.562,249.38a4.534,4.534,0,0,0-1.107-.213c-.174-.02-.339-.056-.367-.176a.886.886,0,0,1,.122-.516l.531-1.322a22.833,22.833,0,0,0,1.2-3.46,22.859,22.859,0,0,0-1.474,3.355l-.51,1.33a1.01,1.01,0,0,0-.1.683.438.438,0,0,0,.284.258,1.209,1.209,0,0,0,.3.044A4.456,4.456,0,0,0,135.562,249.38Z",
    transform: "translate(-133.828 -243.694)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.733 19.98)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M136.273,270.627a12.585,12.585,0,0,0,6.647-1.691s-1.647,3.38-6.594,2.86Z",
    transform: "translate(-136.273 -268.936)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.498 14.792)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M137.942,258.54a1.231,1.231,0,0,1,1.108-.444,1.123,1.123,0,0,1,.771.425.711.711,0,0,1,.045.814.826.826,0,0,1-.9.216,2.586,2.586,0,0,1-.867-.531.749.749,0,0,1-.193-.2.229.229,0,0,1,0-.254",
    transform: "translate(-137.873 -258.086)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.105 14.091)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M139.248,256.622c-.111-.008-.121.734-.762,1.252s-1.428.428-1.436.532c-.011.046.175.146.508.159a1.844,1.844,0,0,0,1.2-.4,1.606,1.606,0,0,0,.591-1.051C139.379,256.8,139.3,256.618,139.248,256.622Z",
    transform: "translate(-137.05 -256.622)"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M140.37,224.718c-1.811,2.582-6.6,5.237-10.037,5.854.4-.527,2.509-1.828,2.91-2.355-1.556,1.162-3.783,2.716-5.847,2.821a1.253,1.253,0,0,1-.709-.11.957.957,0,0,1-.361-.778,20.624,20.624,0,0,1,.143-4.484,4.962,4.962,0,0,1,1.786-3.2,8.566,8.566,0,0,1,5-1.316,11.309,11.309,0,0,1,4.4.592,4.132,4.132,0,0,1,2.737,2.889",
    transform: "translate(-126.261 -221.142)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.901 0.572)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M156.364,236.911a28.016,28.016,0,0,0,.494-3.308c.146-2.554-.592-11.979-9.4-11.22l-.355,2.681s-1.361,9.179,4.334,9.247a10.24,10.24,0,0,0,2.894,5.4s1.493-.045,2.029-2.8",
    transform: "translate(-146.965 -222.339)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.133 12.488)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M156.06,247.312a2.953,2.953,0,0,1,1.591.121,2.06,2.06,0,0,1,1.154,1.071,2.154,2.154,0,0,1,0,1.582,3.645,3.645,0,0,1-.917,1.32,2.472,2.472,0,0,1-.968.626,1.18,1.18,0,0,1-1.1-.184",
    transform: "translate(-155.816 -247.257)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.624 13.228)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M156.85,251.331c-.061.019.165.342.651.217a1.043,1.043,0,0,0,.6-.515,2.348,2.348,0,0,0,.274-.875,1.381,1.381,0,0,0-.213-.934.92.92,0,0,0-.69-.419c-.5-.017-.656.326-.6.337.039.041.234-.135.559-.053a.892.892,0,0,1,.539,1.028c-.065.544-.28,1.04-.571,1.161C157.1,251.429,156.884,251.288,156.85,251.331Z",
    transform: "translate(-156.841 -248.805)"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M157.51,222.359a3,3,0,0,0,4.063-1.068,1.922,1.922,0,0,0,.278-1.436,1.976,1.976,0,0,0-1.479-1.282,3.021,3.021,0,0,0-2.776.667,2.651,2.651,0,0,0-.717,2.725,2.364,2.364,0,0,0,2.283,1.576",
    transform: "translate(-136.68 -218.404)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M156.852,256.445a6.972,6.972,0,0,0-1.369,1.18,2.357,2.357,0,0,0-.591,1.665,4.334,4.334,0,0,1,.111,1,3.353,3.353,0,0,1-.694,1.193,2.835,2.835,0,0,0,.447,3.323,4.6,4.6,0,0,0,3.253,1.322,2.784,2.784,0,0,0,3.16-3.136",
    transform: "translate(-135.219 -238.216)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(16.956 5.928)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M155.508,230.724a3.253,3.253,0,0,1-.519.9,10.456,10.456,0,0,1-3.786,3.254,3.262,3.262,0,0,1-.97.377,15.328,15.328,0,0,0,5.275-4.534Z",
    transform: "translate(-150.233 -230.723)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(18.992 5.881)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M158.644,230.624a3.921,3.921,0,0,1-.162,1.207,9.746,9.746,0,0,1-3,4.984,3.914,3.914,0,0,1-.99.709,12.289,12.289,0,0,0,4.151-6.9Z",
    transform: "translate(-154.491 -230.624)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.99 9.866)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M123.159,238.958c.073-.005.167.823.453,1.8s.641,1.732.576,1.766a5.664,5.664,0,0,1-1.03-3.567Z",
    transform: "translate(-123.121 -238.958)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(23.152 10.9)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M165.158,257a1.383,1.383,0,0,0,.728.234,1.489,1.489,0,0,0,.843-.265,1.7,1.7,0,0,0,.638-.966,3.116,3.116,0,0,0,.009-1.441c-.1-.519-.3-1.055-.482-1.641a4.329,4.329,0,0,1-.212-1.927,10.816,10.816,0,0,1,.786-1.9,2.485,2.485,0,0,0-1.452-3.085c-.274-.117-.557-.216-.82-.359a1.672,1.672,0,0,1-.655-.587,2.754,2.754,0,0,1-.3-1.5,5.139,5.139,0,0,0-.049-1.216,1.987,1.987,0,0,0-.359-.823,1.184,1.184,0,0,0-.645-.4.436.436,0,0,1,.208.016,1,1,0,0,1,.51.319,2.022,2.022,0,0,1,.421.856,5.016,5.016,0,0,1,.089,1.247,2.618,2.618,0,0,0,.294,1.393,2.66,2.66,0,0,0,1.39.845,2.711,2.711,0,0,1,1.6,3.379,11.466,11.466,0,0,0-.78,1.857,4.143,4.143,0,0,0,.192,1.821c.167.576.365,1.125.464,1.667a3.248,3.248,0,0,1-.043,1.529,1.825,1.825,0,0,1-.73,1.033,1.555,1.555,0,0,1-.923.247,1.125,1.125,0,0,1-.572-.187A.522.522,0,0,1,165.158,257Z",
    transform: "translate(-163.191 -241.12)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(21.665 18.263)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M160.083,264.7c.022-.014.063.154.295.259a.785.785,0,0,0,.928-.251,1.464,1.464,0,0,0-.077-1.5,6.271,6.271,0,0,1-.953-1.86,1.346,1.346,0,0,1,.266-1.1c.234-.289.509-.481.688-.717a2.084,2.084,0,0,0,.333-1.527,5.925,5.925,0,0,0-.274-1.085,1.425,1.425,0,0,1-.11-.4,1.327,1.327,0,0,1,.2.369,4.658,4.658,0,0,1,.358,1.094,2.213,2.213,0,0,1-.324,1.691c-.2.274-.482.476-.679.729a1.108,1.108,0,0,0-.213.912,6.658,6.658,0,0,0,.911,1.794,1.625,1.625,0,0,1,.016,1.706.857.857,0,0,1-.607.332.839.839,0,0,1-.508-.1C160.078,264.891,160.074,264.7,160.083,264.7Z",
    transform: "translate(-160.081 -256.517)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.497 13.1)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M119.332,257.819a2.131,2.131,0,0,1-.389-.388,4.722,4.722,0,0,1-.834-1.257,2.509,2.509,0,0,1-.2-1.044,1.818,1.818,0,0,1,.421-1.158c.3-.344.726-.522.986-.844a1.409,1.409,0,0,0,.2-1.23,5.247,5.247,0,0,0-.525-1.264,4.339,4.339,0,0,1-.465-1.255,1.641,1.641,0,0,1,.246-1.207,4.212,4.212,0,0,1,.728-.759,2.184,2.184,0,0,0,.817-1.165,1.438,1.438,0,0,0-.021-.527c.006,0,.038.037.072.126a.853.853,0,0,1,.044.416,2.175,2.175,0,0,1-.793,1.28,4.24,4.24,0,0,0-.675.743,1.436,1.436,0,0,0-.193,1.057,4.25,4.25,0,0,0,.456,1.181,5.322,5.322,0,0,1,.55,1.32,1.643,1.643,0,0,1-.252,1.439c-.325.382-.753.548-1,.841a1.624,1.624,0,0,0-.387,1.015,2.39,2.39,0,0,0,.158.971,5.347,5.347,0,0,0,.746,1.261A2.555,2.555,0,0,1,119.332,257.819Z",
    transform: "translate(-117.907 -245.72)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(20.163 2.51)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M159.642,225.645a4.833,4.833,0,0,0-2.7-2.044,2.859,2.859,0,0,1,2.7,2.044Z",
    transform: "translate(-156.94 -223.576)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(22.547)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M162.934,218.327c.025-.016.186.171.315.542a2.591,2.591,0,0,1-.773,2.8c-.3.252-.535.33-.548.3s.176-.164.427-.432a2.845,2.845,0,0,0,.724-2.623A3.614,3.614,0,0,1,162.934,218.327Z",
    transform: "translate(-161.926 -218.326)"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M113.254,338.436s11.881,11.282,18.944,9.239,9.153-7.341,9.153-7.341l.171-1.9-.708-.463-27.191-2.2Z",
    transform: "translate(-98.43 -279.608)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 28.048)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.392 1.12)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M98.555,312.832l2.292-5.875,8.212,5.159L101.741,323.4A19.363,19.363,0,0,1,98.555,312.832Z",
    transform: "translate(-98.152 -293.741)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M107.383,282.178a29.32,29.32,0,0,1,8.769-2.571h0c1.436,2.875,5.963,3.24,8.7,1.278l2.311-1.562a8.388,8.388,0,0,1,.968.04,12.344,12.344,0,0,1,10.933,9.83,24.651,24.651,0,0,1,.578,6.213c-.3,5.224-5.711,5.7-5.711,5.7s-.278,5.164-.644,9.335h0a7.787,7.787,0,0,1-4.732,6.748,19.216,19.216,0,0,1-6.032,1.86,20.256,20.256,0,0,1-17.973-6.223c.821-4.976,1.6-11.419,1.549-11.707a.144.144,0,0,1,.009-.1l-5.362-4.76-3.039-2.552s6.67-9.9,9.671-11.528",
    transform: "translate(-97.712 -279.32)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.328 6.651)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M122.686,291.433a2.85,2.85,0,0,0-1.326-.366,2.181,2.181,0,0,0-1.368.474,5.852,5.852,0,0,0-.609.654,1.585,1.585,0,0,1-.867.576,1.413,1.413,0,0,1-1.01-.271c-.275-.176-.511-.369-.753-.508a1.641,1.641,0,0,0-1.4-.122,1.853,1.853,0,0,0-.815.562c-.151.186-.206.313-.226.3a.732.732,0,0,1,.148-.361,1.85,1.85,0,0,1,2.409-.582c.267.146.509.339.769.5a1.186,1.186,0,0,0,.836.232,1.374,1.374,0,0,0,.731-.494,5.482,5.482,0,0,1,.647-.669,2.292,2.292,0,0,1,1.514-.472,2.18,2.18,0,0,1,1.024.293C122.6,291.316,122.694,291.424,122.686,291.433Z",
    transform: "translate(-114.307 -290.888)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(20.801 12.225)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M134.107,304.653a2.848,2.848,0,0,0-1.139-.771,2.179,2.179,0,0,0-1.447.012,5.78,5.78,0,0,0-.786.425,1.585,1.585,0,0,1-1.007.268,1.411,1.411,0,0,1-.87-.579c-.205-.255-.366-.513-.551-.722a1.642,1.642,0,0,0-1.29-.564,1.853,1.853,0,0,0-.952.272c-.2.129-.295.231-.311.216s.058-.133.255-.3a1.85,1.85,0,0,1,2.469.218c.206.224.374.484.569.721a1.19,1.19,0,0,0,.719.487,1.372,1.372,0,0,0,.85-.235,5.493,5.493,0,0,1,.826-.428,2.293,2.293,0,0,1,1.585.037,2.187,2.187,0,0,1,.878.6A.811.811,0,0,1,134.107,304.653Z",
    transform: "translate(-125.752 -302.542)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(33.341 3.597)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M159.892,284.786a2.841,2.841,0,0,0-1.373-.078,2.181,2.181,0,0,0-1.236.753,5.713,5.713,0,0,0-.457.768,1.581,1.581,0,0,1-.726.746,1.41,1.41,0,0,1-1.044-.05c-.307-.114-.578-.253-.844-.337a1.64,1.64,0,0,0-1.4.177,1.854,1.854,0,0,0-.678.722c-.108.214-.134.35-.156.345a.729.729,0,0,1,.068-.384,1.85,1.85,0,0,1,2.231-1.079c.291.086.569.224.858.327a1.187,1.187,0,0,0,.867.05,1.376,1.376,0,0,0,.61-.637,5.449,5.449,0,0,1,.49-.791,2.293,2.293,0,0,1,1.38-.781,2.184,2.184,0,0,1,1.063.069A.807.807,0,0,1,159.892,284.786Z",
    transform: "translate(-151.974 -284.501)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(29.284 9.837)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M149.881,299.44a2.45,2.45,0,0,0-.859-.615,1.668,1.668,0,0,0-1.1-.034,4.481,4.481,0,0,0-.616.3,1.247,1.247,0,0,1-.8.175,1.114,1.114,0,0,1-.668-.488c-.15-.206-.265-.41-.4-.576a1.248,1.248,0,0,0-.954-.476,1.739,1.739,0,0,0-.991.312c-.01-.008.044-.106.2-.228a1.378,1.378,0,0,1,.791-.26,1.4,1.4,0,0,1,1.131.507c.153.181.274.388.416.575a.892.892,0,0,0,.52.389c.439.077.843-.318,1.3-.45a1.781,1.781,0,0,1,1.236.09C149.753,298.968,149.906,299.446,149.881,299.44Z",
    transform: "translate(-143.491 -297.549)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(16.968 16.446)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M124.125,313.261a2.425,2.425,0,0,0-.858-.615,1.671,1.671,0,0,0-1.1-.034,4.481,4.481,0,0,0-.616.3,1.244,1.244,0,0,1-.8.175,1.115,1.115,0,0,1-.668-.488c-.15-.206-.264-.41-.4-.576a1.251,1.251,0,0,0-.955-.476,1.737,1.737,0,0,0-.99.313c-.01-.008.044-.106.2-.228a1.377,1.377,0,0,1,.791-.261,1.4,1.4,0,0,1,1.131.507c.154.182.274.388.416.575a.889.889,0,0,0,.52.389c.439.077.843-.318,1.3-.45a1.784,1.784,0,0,1,1.236.09C124,312.788,124.15,313.266,124.125,313.261Z",
    transform: "translate(-117.736 -311.369)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(28.369 17.998)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M148.079,315.1a2.447,2.447,0,0,0-1.012-.3,1.666,1.666,0,0,0-1.052.324,4.426,4.426,0,0,0-.485.483,1.247,1.247,0,0,1-.7.425,1.113,1.113,0,0,1-.79-.246c-.209-.146-.384-.3-.563-.416a1.249,1.249,0,0,0-1.057-.142,1.743,1.743,0,0,0-.836.616c-.012,0,.007-.114.117-.281a1.378,1.378,0,0,1,.664-.5,1.4,1.4,0,0,1,1.234.113c.2.122.385.279.58.41a.891.891,0,0,0,.618.2c.441-.069.695-.574,1.087-.847a1.781,1.781,0,0,1,1.2-.315A1.292,1.292,0,0,1,148.079,315.1Z",
    transform: "translate(-141.577 -314.615)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(24.566 23.25)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M140.126,326.086a2.433,2.433,0,0,0-1.012-.3,1.672,1.672,0,0,0-1.052.324,4.434,4.434,0,0,0-.485.483,1.247,1.247,0,0,1-.7.425,1.115,1.115,0,0,1-.79-.245c-.209-.146-.384-.3-.563-.416a1.249,1.249,0,0,0-1.057-.142,1.738,1.738,0,0,0-.836.616c-.012,0,.007-.115.117-.281a1.375,1.375,0,0,1,.664-.5,1.4,1.4,0,0,1,1.234.114c.2.122.385.278.58.409a.889.889,0,0,0,.618.2c.441-.069.695-.574,1.087-.846a1.779,1.779,0,0,1,1.2-.315A1.29,1.29,0,0,1,140.126,326.086Z",
    transform: "translate(-133.624 -325.598)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(16.627 34.959)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M123.433,351.9a2.431,2.431,0,0,0-.867-.6,1.669,1.669,0,0,0-1.1-.019,4.538,4.538,0,0,0-.612.309,1.243,1.243,0,0,1-.8.186,1.112,1.112,0,0,1-.675-.478c-.153-.2-.27-.406-.406-.57a1.25,1.25,0,0,0-.962-.462,1.744,1.744,0,0,0-.986.326c-.01-.008.043-.107.2-.23a1.376,1.376,0,0,1,.787-.272,1.4,1.4,0,0,1,1.138.491c.156.179.28.384.424.569a.887.887,0,0,0,.525.382c.441.071.839-.33,1.3-.468a1.781,1.781,0,0,1,1.237.072C123.3,351.428,123.458,351.9,123.433,351.9Z",
    transform: "translate(-117.024 -350.083)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(25.923 39.043)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M142.973,359.127a2.438,2.438,0,0,0-1.008-.319,1.67,1.67,0,0,0-1.056.309,4.527,4.527,0,0,0-.492.477,1.246,1.246,0,0,1-.709.416,1.115,1.115,0,0,1-.786-.256c-.207-.149-.379-.308-.557-.424a1.251,1.251,0,0,0-1.055-.156,1.738,1.738,0,0,0-.845.6c-.012,0,.009-.115.121-.279a1.378,1.378,0,0,1,.671-.493,1.4,1.4,0,0,1,1.232.131c.2.125.382.284.574.417a.889.889,0,0,0,.615.209c.442-.063.7-.564,1.1-.832a1.779,1.779,0,0,1,1.2-.3A1.289,1.289,0,0,1,142.973,359.127Z",
    transform: "translate(-136.462 -358.623)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M83.719,276.979c.29.342,10.8,14.4,10.8,14.4l-1.48.839-10.789-13.88Z",
    transform: "translate(-82.254 -276.979)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M128.412,294.244s-9.862,17.007-10.528,17.319c-1.313.616-16.445-12.46-17.887-13.711-.2-.266-.609-.826-1.415-1.942,0,0-1.194-5.463-2.468-5.044s.7,2.776-.132,4.852-4.63-2.875-4.782-3.32l-.98-1.28a16.818,16.818,0,0,0-.958,4.13c.223,3.9,3.911,8.533,3.911,8.533s14.984,18.776,26.328,19.413c3.267.183,9.508-9.223,13.389-16.174,2.344-4.2,1.256-8.462-2.629-11.295Z",
    transform: "translate(-85.909 -284.214)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.785 8.847)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M91.6,298.36a8.979,8.979,0,0,1-1.426-2.881,16.054,16.054,0,0,1,.717,1.438C91.281,297.712,91.635,298.338,91.6,298.36Z",
    transform: "translate(-90.169 -295.479)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M159.733,288.061c-.39.234-9.56,17.258-9.56,17.258l11.8,9.246a136.715,136.715,0,0,0,4.69-13.714,19.706,19.706,0,0,0-.407-7.85c-.882-2.445-2.212-1.836-4.2-3.269Z",
    transform: "translate(-117.694 -282.762)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "o",
    transform: "translate(32.323 4.808)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M163.44,287.524c-.007.011-.116-.065-.337-.176a1.982,1.982,0,0,0-1.038-.218,2.831,2.831,0,0,0-1.54.643,7.647,7.647,0,0,0-1.536,1.655c-.5.68-.911,1.509-1.414,2.373L156,294.571l-3.628,6.337-2.263,3.934-.031-.155L158.063,311l2.317,1.86.614.507a1.3,1.3,0,0,1,.2.187,1.363,1.363,0,0,1-.23-.153l-.639-.475-2.361-1.8-8.041-6.243-.082-.064.052-.091,2.256-3.936,3.644-6.326,1.6-2.757a27.3,27.3,0,0,1,1.453-2.378,7.651,7.651,0,0,1,1.6-1.664,2.9,2.9,0,0,1,1.619-.628,1.953,1.953,0,0,1,1.065.271,1.728,1.728,0,0,1,.239.157C163.417,287.5,163.442,287.521,163.44,287.524Z",
    transform: "translate(-149.845 -287.032)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(36.003 19.371)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M163.931,319.378a2.444,2.444,0,0,0-.859-.615,1.671,1.671,0,0,0-1.1-.034,4.594,4.594,0,0,0-.616.3,1.247,1.247,0,0,1-.8.175,1.115,1.115,0,0,1-.668-.488c-.15-.206-.265-.41-.4-.576a1.251,1.251,0,0,0-.954-.476,1.741,1.741,0,0,0-.991.313c-.01-.008.044-.106.2-.228a1.378,1.378,0,0,1,.791-.261,1.4,1.4,0,0,1,1.13.507c.154.182.274.388.416.575a.89.89,0,0,0,.52.389c.439.077.843-.318,1.3-.449a1.781,1.781,0,0,1,1.236.09C163.8,318.905,163.956,319.383,163.931,319.378Z",
    transform: "translate(-157.541 -317.486)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(42.014 15.739)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M175.884,313.212a2.441,2.441,0,0,0-.661-.824,1.669,1.669,0,0,0-1.051-.33,4.51,4.51,0,0,0-.674.123,1.247,1.247,0,0,1-.82-.049,1.113,1.113,0,0,1-.512-.65c-.089-.239-.144-.466-.228-.661a1.251,1.251,0,0,0-.791-.716,1.739,1.739,0,0,0-1.038.034c-.007-.01.071-.09.255-.165a1.378,1.378,0,0,1,.832-.037,1.4,1.4,0,0,1,.953.793c.1.216.159.448.245.666a.892.892,0,0,0,.4.515c.4.193.9-.079,1.375-.081a1.782,1.782,0,0,1,1.166.42A1.291,1.291,0,0,1,175.884,313.212Z",
    transform: "translate(-170.11 -309.89)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(42.291 8.701)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M176.464,298.5a2.432,2.432,0,0,0-.661-.824,1.67,1.67,0,0,0-1.05-.329,4.421,4.421,0,0,0-.674.123,1.245,1.245,0,0,1-.821-.048,1.114,1.114,0,0,1-.511-.65c-.089-.239-.144-.466-.228-.662a1.249,1.249,0,0,0-.791-.716,1.736,1.736,0,0,0-1.038.033c-.007-.01.071-.09.255-.165a1.38,1.38,0,0,1,.832-.037,1.4,1.4,0,0,1,.952.793c.1.216.16.448.245.666a.889.889,0,0,0,.4.515c.4.193.9-.079,1.375-.081a1.782,1.782,0,0,1,1.165.42A1.287,1.287,0,0,1,176.464,298.5Z",
    transform: "translate(-170.69 -295.174)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(39.679 24.879)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M171,332.327a2.44,2.44,0,0,0-.661-.824,1.67,1.67,0,0,0-1.051-.329,4.508,4.508,0,0,0-.674.123,1.244,1.244,0,0,1-.82-.048,1.114,1.114,0,0,1-.512-.65c-.089-.239-.144-.466-.228-.662a1.249,1.249,0,0,0-.791-.716,1.739,1.739,0,0,0-1.038.033c-.008-.01.071-.09.255-.165a1.374,1.374,0,0,1,.832-.038,1.405,1.405,0,0,1,.953.793c.1.216.159.448.245.666a.891.891,0,0,0,.4.516c.4.193.9-.079,1.375-.082a1.784,1.784,0,0,1,1.166.42A1.29,1.29,0,0,1,171,332.327Z",
    transform: "translate(-165.229 -329.004)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedbackCommingSoon);
export default __webpack_public_path__ + "static/media/feedback_comming_soon.591a1857864d59ea51b20069343df3fe.svg";
export { ForwardRef as ReactComponent };